export default __webpack_public_path__ + "static/media/Golden Wine of Xuthal.fe9c8585.jpg";